export const VIEWER_CONTAINER_ID = 'container';

export const TEXT_MARK_MAX_LENGTH = 50;
